"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: "Social"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M14.89 13.753a5.597 5.597 0 0 0-2.192-8.451A6.397 6.397 0 1 0 1.353 10.33L.24 11.434a.8.8 0 0 0-.168.872.8.8 0 0 0 .736.496h4.55A5.597 5.597 0 0 0 10.403 16H15.2a.8.8 0 0 0 .736-.496.8.8 0 0 0-.168-.871l-.88-.88Zm-10.083-3.35c0 .268.022.535.064.8H2.736l.28-.272a.8.8 0 0 0 0-1.136 4.742 4.742 0 0 1-1.407-3.39 4.798 4.798 0 0 1 4.797-4.798 4.75 4.75 0 0 1 4.517 3.199h-.52a5.597 5.597 0 0 0-5.596 5.597Zm8.427 3.998.04.04h-2.87a3.998 3.998 0 1 1 2.83-1.168.8.8 0 0 0-.24.56.8.8 0 0 0 .24.568Z",
      fill: "currentColor"
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsxs)("g", {
        fillRule: "nonzero",
        children: [(0, _jsxRuntime.jsx)("path", {
          d: "M8.976 4.208a1.653 1.653 0 0 0-1.26-.572c-.69 0-1.126.415-1.372.762-.064.09-.117.18-.162.266a2.572 2.572 0 0 0-.163-.266c-.245-.347-.682-.762-1.371-.762-.491 0-.939.204-1.26.572a2.007 2.007 0 0 0-.479 1.326c0 .548.212 1.057.669 1.604.408.489.994.992 1.674 1.574.254.218.516.442.794.687l.01.008a.19.19 0 0 0 .126.048.19.19 0 0 0 .126-.048l.01-.008c.278-.245.22-1.182.473-1.399.68-.583 1.128-.966 1.536-1.455.456-.546 1.128-.463 1.128-1.011 0-.503-.17-.974-.479-1.326Z",
          fill: "currentColor"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M6.781 8.214c-.193.164-.39.332-.6.513-.208-.181-.406-.35-.598-.513-1.173-1-1.947-1.66-1.947-2.527 0-.358.12-.691.337-.937.219-.249.524-.386.857-.386.463 0 .763.285.933.525.152.215.232.43.259.514a.17.17 0 0 0 .322 0c.027-.083.107-.3.26-.514.167-.24.466-.525.93-.525.333 0 .638.137.857.386.217.247.336.579.336.937 0 .672-.69 1.04-1.444 1.718-.22.197-.237.583-.502.809Z",
          fill: "transparent"
        })]
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M7.798 9.818H8.93c.09 0 .162.072.162.161v2.587a.161.161 0 0 1-.162.161H7.8a.161.161 0 0 1-.163-.16V9.978c.001-.09.073-.16.162-.16Zm2.02 2.71v-1.81c0-.445.132-.882.378-1.26.15-.23.487-.596.676-.786.042-.043.194-.168.194-.237 0-.088.01-.23.014-.494a.315.315 0 0 1 .322-.305h.007a.446.446 0 0 1 .407.278s.263.495.017 1.102c-.207.512-.25.553-.25.553s-.067.093.146.089l1.341-.006c.096 0 .401.084.384.455-.013.274-.192.37-.283.402a.02.02 0 0 0-.013.028.024.024 0 0 0 .01.01c.094.053.285.184.28.385-.005.244-.107.334-.321.39-.012.003-.02.015-.016.026a.02.02 0 0 0 .01.013c.081.044.22.152.212.369-.008.221-.176.299-.268.326a.021.021 0 0 0-.015.026c.001.005.005.01.009.012.058.038.144.124.14.3a.326.326 0 0 1-.076.21.357.357 0 0 1-.27.118l-2.878.005c-.001 0-.157 0-.157-.199Z",
        fill: "currentColor",
        fillRule: "nonzero"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Social.js.map